import { render, staticRenderFns } from "./SamsPayUclan.vue?vue&type=template&id=8cb31ebe"
import script from "./SamsPayUclan.vue?vue&type=script&lang=js"
export * from "./SamsPayUclan.vue?vue&type=script&lang=js"
import style0 from "./SamsPayUclan.vue?vue&type=style&index=0&id=8cb31ebe&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports